// extracted by mini-css-extract-plugin
export var center = "footer-module--center--vAsAh";
export var copy = "footer-module--copy--vLGY+";
export var footerContent = "footer-module--footer-content--A0BdU";
export var footerInfo = "footer-module--footer-info--7hyeW";
export var footerInfoContainer = "footer-module--footer-info-container--6DtMw";
export var footerSocial = "footer-module--footer-social--K5ZrI";
export var footerWrapper = "footer-module--footer-wrapper--WEuN4";
export var imgContainer = "footer-module--img-container--H4OUA";
export var pt8 = "footer-module--pt8--QtRUw";